import { nodeListToArray } from '../helpers/nodeListToArray';

export class siteSearch {
    constructor() {
        let siteSearchContainer = nodeListToArray(document.querySelectorAll('.site-search-js'));
        siteSearchContainer.forEach(siteSearch => {
            this.inputHandler(siteSearch);
        });

        this.toggleSearch(document.querySelector('.search-toggle-js'));
    }

    // Search input handler when in webforms
    inputHandler(siteSearch) {
        const searchForm = siteSearch.querySelector('.site-search-form-js');
        const searchField = siteSearch.querySelector('.site-search-input-js');

        function doSearch() {
            // Check if no form exists and that field value is not empty
            if (!searchForm && (searchField.value != '' || null)) {
                window.location.href = `${searchField.dataset.searchPage}?q=${searchField.value}`;
            }
        }

        // Check if no form exists (inside of webforms)
        if (!searchForm) {
            searchField.addEventListener('keyup', function(e) {
                e.preventDefault();

                if (e.keyCode == 13) {
                    doSearch();
                }
            });

            siteSearch.querySelector('.site-search-btn-js').addEventListener('click', function(e) {
                e.preventDefault();
                doSearch();
            });
        }
    }

    toggleSearch(headerSearchTrigger) {
        const headerSearchContainer = headerSearchTrigger.parentNode.querySelector('.search-control-js') as HTMLElement;
        const searchField = headerSearchContainer.querySelector('.site-search-input-js') as HTMLElement;

        headerSearchTrigger.addEventListener('click', function(e) {
            e.preventDefault();
            headerSearchContainer.classList.remove('search-control-hidden');

            searchField.focus();
            //searchField.addEventListener('blur', hideSearch);
        });

        // function hideSearch() {
        //     headerSearchContainer.classList.add('search-control-hidden');
        //     searchField.removeEventListener('blue', hideSearch);
        // }
    }
}
